module.exports = __webpack_public_path__ + "static/media/share-icon.9ccd5abd.svg";